import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type WebDestinationPromptState = {
    fetching: FetchingStatus | null;
    value: string;
};

const initialState: WebDestinationPromptState = {
    fetching: null,
    value: '',
};

function setFetchingFunction(state: WebDestinationPromptState, action: PayloadAction<WebDestinationPromptState['fetching']>) {
    return {
        ...state,
        fetching: action.payload,
    };
}

function setPromptFunction(
    state: WebDestinationPromptState,
    action: PayloadAction<string>
) {
    return {
        ...state,
        value: action.payload,
    };
}

const slice = createSlice({
    name: 'hotelManager.webDestinationPrompt',
    initialState,
    reducers: {
        setFetching: setFetchingFunction,
        setPrompt: setPromptFunction,
    },
});

export const { setFetching, setPrompt } = slice.actions;
export default slice.reducer; 